<template>
  <el-table
    :data="countTable"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
    border
    style="width: 100%;"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      :label="tableHeadText"
      align="center"
    >
      <el-table-column
        :prop="dataType != 'itemTag' ? 'skuId' : 'classifyName'"
        :label="firstColumnLabel"
        width="180"
        align="center"
      />
      <el-table-column
        prop="skuName"
        :label="secondColumnLabel"
        width="180"
        align="center"
      >
        <template slot-scope="{ row }">
          <textOverflowTooltip :content="row.skuName" :lines="1" />
        </template>
      </el-table-column>
      <el-table-column
        prop="buyCount"
        label="购买人数"
        width="120"
        align="center"
      />
      <el-table-column
        prop="buyOrderCount"
        label="购买单量"
        width="120"
        align="center"
      />
      <el-table-column
        prop="buyItemCount"
        label="购买件数"
        width="120"
        align="center"
      />
      <el-table-column
        prop="buyAmount"
        label="购买金额"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="rank"
        label="排名"
        width="100"
        align="center"
      />
      <el-table-column
        :prop="dataType != 'itemTag' ? 'repurchaseSkuId' : 'repurchaseClassifyName'"
        :label="thirdColumnLabel"
        width="180"
        align="center"
      />
      <el-table-column
        prop="repurchaseSkuName"
        :label="fourthColumnLabel"
        width="180"
        align="center"
      >
        <template slot-scope="{ row }">
          <textOverflowTooltip :content="row.repurchaseSkuName" :lines="1" />
        </template>
      </el-table-column>
      <el-table-column
        prop="repurchaseCount"
        label="售前购买人数"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="repurchaseOrderCount"
        label="售前购买单量"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="repurchaseItemCount"
        label="售前购买件数"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="repurchaseAmount"
        label="售前购买金额"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="repurchaseRatio"
        label="售前关联人数比"
        min-width="120"
        align="center"
      />
    </el-table-column>
  </el-table>
</template>

<script>
import dayjs from "dayjs";
import mixins from "../../../mixins/index.js";
import Empty from "../../../components/empty.vue";

export default {
  name: "PreSalesTable",
  mixins: [mixins],
  components: {
    Empty,
    textOverflowTooltip: () => import("@/components/ai/components/prefabricateReport/components/textOverflowTooltip.vue"),
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    dataType: {
      type: String,
      default: "sku",
    },
    reportParams: {
      type: Object,
      default: () => ({}),
    },
    payTimeStart: {
      type: String,
      default: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
    },
    payTimeEnd: {
      type: String,
      default: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
    },
  },
  computed: {
    countTable() {
      const tableList = [];
      (this.tableData || []).forEach((item1) => {
        if (item1.repurchaseList && item1.repurchaseList.length > 0) {
          item1.repurchaseList.forEach((item2) => {
            const row = {
              ...item1,
              ...item2,
            }
            delete row.repurchaseList;
            delete row.repurchaseJson;
            tableList.push(row);
          });
        } else {
          const row = { 
            ...item1,
            // rank: '-',
            // repurchaseAmount: '-',
            // repurchaseCount: '-',
            // repurchaseItemCount: '-',
            // repurchaseOrderCount: '-',
            // repurchaseRatio: '-',
            // repurchaseRateStr: '-',
            // repurchaseSkuId: '-',
            // repurchaseSkuName: '-',
            // repurchaseClassifyId: '-',
            // repurchaseClassifyName: '-',
          }
          delete row.repurchaseList;
          delete row.repurchaseJson;
          tableList.push(row);
        }
      });
      const ignoreKeys = [
        "index",
        "skuId",
        "skuName",
        "classifyId",
        "classifyName",
        "rank",
        "repurchaseSkuId",
        "repurchaseSkuName",
        "repurchaseClassifyId",
        "repurchaseClassifyName",
      ];
      return tableList.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          if (ignoreKeys.includes(key)) {
            newRow[key] = row[key];
            return;
          }
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else if (key.includes("Count") || key.includes("Amount")) {
            newRow[key] = this.formatNumber(row[key]);
          } else {
            newRow[key] = row[key];
          }
        });
        return newRow;
      });
    },
    firstColumnLabel() {
      const map = {
        sku: "skuId",
        spu: "商品Id",
        category: "类目Id",
        sellerCategory: "类目Id",
        itemTag: "标签分类",
      };
      return map[this.dataType] || "";
    },
    secondColumnLabel() {
      const map = {
        sku: "商品名称",
        spu: "商品名称",
        category: "类目名称",
        sellerCategory: "类目名称",
        itemTag: "标签名称",
      };
      return map[this.dataType] || "";
    },
    thirdColumnLabel() {
      const map = {
        sku: "售前购买skuId",
        spu: "售前购买商品Id",
        category: "售前购买类目Id",
        sellerCategory: "售前购买类目Id",
        itemTag: "售前购买标签分类",
      };
      return map[this.dataType] || "";
    },
    fourthColumnLabel() {
      const map = {
        sku: "售前购买商品名称",
        spu: "售前购买商品名称",
        category: "售前购买类目名称",
        sellerCategory: "售前购买类目名称",
        itemTag: "售前购买标签名称",
      };
      return map[this.dataType] || "";
    },
    mergeColumnMap() {
      // const field = this.dataType != 'itemTag' ? 'skuId' : 'classifyName';
      // const columns = [field, 'skuName', 'buyCount', 'buyOrderCount', 'buyItemCount', 'buyAmount']; // 指定要合并的列，需要全部相等才合并
      const columns = this.dataType != 'itemTag'
                      ? ['skuId', 'skuName', 'buyCount', 'buyOrderCount', 'buyItemCount', 'buyAmount']
                      : ['index', 'skuId', 'skuName', 'classifyId', 'classifyName', 'buyCount', 'buyOrderCount', 'buyItemCount', 'buyAmount'];
      return columns.reduce((prev, cur) => {
        prev[cur] = [ ...columns ];
        return prev;
      }, {});
    },
    spanData() {
      // 处理合计行
      const firstColProp = this.dataType != 'itemTag' ? 'skuId' : 'classifyName';
      const secondColProp = 'skuName';
      const firstRow = this.countTable[0] || {};
      const isFirstRowTotal = firstRow[firstColProp] === firstRow[secondColProp] && firstRow[firstColProp] === '合计';
      // 计算跨行合并
      const mergeMap = {};
      Object.keys(this.mergeColumnMap).forEach((prop) => {
        const posArr = [];
        let pos = 0;
        this.countTable.forEach((item, index) => {
          if (index === 0) {
            posArr.push(1);
            pos = 0;
          } else if (isFirstRowTotal && index === 1) {
            posArr.push(1);
            pos = index;
          } else {
            let isSame = this.mergeColumnMap[prop].every((checkProp) => item[checkProp] === this.countTable[index - 1][checkProp]);
            if (isSame) {
              posArr[pos] += 1;
              posArr.push(0);
            } else {
              posArr.push(1);
              pos = index;
            }
          }
        });
        mergeMap[prop] = posArr;
      });
      return mergeMap;
    },
    rebuyTimeStart(){
			return this.reportParams.rebuyTimeStart || dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00";
		},
    rebuyTimeEnd(){
			return this.reportParams.rebuyTimeEnd || dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59";
		},
    tableHeadText() {
      return `(付款时间${this.formatDateStr(this.payTimeStart)}00:00:00-${this.formatDateStr(this.payTimeEnd)}23:59:59，
               售前时间${this.formatDateStr(this.rebuyTimeStart)}00:00:00-${this.formatDateStr(this.rebuyTimeEnd)}23:59:59)`;
    },
		prevReportView(){
			return this.reportParams.reportView || 0;
		},
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 处理第一行是合计行情况
      if (rowIndex == 0) {
        const firstColProp = this.dataType != 'itemTag' ? 'skuId' : 'classifyName';
        const secondColProp = 'skuName';
        const v1 = row[firstColProp];
        const v2 = row[secondColProp];
        if (v1 === v2 && v1 === '合计') {
          if (column.property === firstColProp) {
            return { rowspan: 1, colspan: 2 };
          }
          if (column.property === secondColProp) {
            return { rowspan: 1, colspan: 0 };
          }
          return { rowspan: 1, colspan: 1 };
        }
      }
      if (this.prevReportView == 1) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
      if (this.mergeColumnMap[column.property]) {
        const rowspan = this.spanData[column.property][rowIndex] || 0;
        return {
          rowspan: rowspan,
          colspan: rowspan > 0 ? 1 : 0,
        };
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
    formatDateStr(dateStr) {
      if (!dateStr) return " 年 月 日";
      return dayjs(dateStr).format("YYYY年MM月DD日");
    },
  },
};
</script>
